import React from 'react'
import ViewLabelValueField from '../frontend_components/ViewLabelValueField'
import { offerTotalsFormatted } from '../../lib/utils'

const OfferTotals = ({offerTotals, border}) => {
   //#offerTotals
   const prezzoCliente = offerTotalsFormatted(offerTotals)?.priceToClient
   const margine = offerTotalsFormatted(offerTotals)?.margin
   
   const costo = offerTotalsFormatted(offerTotals)?.cost
   const profitto = offerTotalsFormatted(offerTotals)?.profit
   //console.log("IN CONSOLE TOTALS", offerTotalsFormatted(offerTotals))

  return (
    <>
            <ViewLabelValueField
            noBorder={!border}
            boldValue
            label={"PREZZO"}
            value={prezzoCliente}
            //highlight={"blue"}
          />
          <ViewLabelValueField
            noBorder={!border}
            boldValue
            label={"COSTO"}
            value={costo}
            //highlight={"amber"}
          />
          <ViewLabelValueField
            noBorder={!border}
            boldValue
            label={"PROFITTO"}
            value={profitto}
            highlight={offerTotalsFormatted(offerTotals)?.marginColor}
          />
          <ViewLabelValueField
            noBorder={!border}
            boldValue
            label={"MARGINE"}
            value={margine}
            highlight={offerTotalsFormatted(offerTotals)?.marginColor}
          />
    </>
  )
}

export default OfferTotals
